/**
 * Numeric Zendesk conversation-field IDs, configured in the Zendesk admin.
 * Kept in this side-effect-free module (no `import.meta`) so e2e specs can
 * import it without dragging in `zendesk.ts` and breaking Playwright's loader.
 */
export const ZENDESK_FIELD_IDS = {
  userId: "47675630633745",
  appVersion: "47834234172561",
  platform: "48557431914769",
  deviceType: "47834276000401",
  subscriptionStatus: "47179996105617",
  browser: "47825157339537",
} as const;
